import axios from "./axios-config";

export const getAllCategories = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/categories?type=${keyword ?? ""}`)
    return (data);

}
export const getAllCategoriesWithType = async (type) => {

    let { data } = await axios.get(`/super-admin/categories?type=${type ?? ""}`)
    return (data);

}

export const getSingleCategory = async (id) => {

    let { data } = await axios.get(`/super-admin/categories/` + id)
    return data;

}
export const deleteSingleCategory = async (id) => {
    let { data } = await axios.delete(`/super-admin/categories/` + id)
    return data;
}

export const updateSingleCategories = async (updateData) => {

    let { data } = await axios.post(`/super-admin/categories/${updateData.category_id}?_method=put`, {title:updateData.title,parent_id:updateData.parent_id})
    return data;
}

export const storeSingleCategories = async (storeData) => {

    let { data } = await axios.post(`/super-admin/categories`, storeData)
    return data
}


// export const getBlogCategories = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Categories/all/blogs`, data)
//     return data;
// }

export const getWorkshopCategories = async (data) => {
    try {
        let response = await axios.post(`/super-admin/Categories/all/workshops`, data)
        return (response.data);
    } catch (error) {
        return (error);
    }
}

